import { ApiError } from "@vana/core";

export class GetSummaryError extends ApiError {}
